module.exports = __webpack_public_path__ + "444769823dc0b3139a425a695a34456e.otf";